// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.switch-button-red-deactivate.switch input[type='checkbox'] + .check {\n  background: #ff3860;\n}\n.switch-button-red-deactivate.switch:hover input[type='checkbox'] + .check {\n  background: #ff3860;\n}\ntr.border_bottom:not(:last-child) {\n  border-bottom: 1pt solid grey;\n}\n", ""]);
// Exports
module.exports = exports;
